import React from 'react';
import { MessageCircleIcon, SendIcon, MailIcon } from 'lucide-react';
interface ServicePackage {
  id: string;
  title: string;
  price: string;
  features: string[];
  recommended?: boolean;
}
interface PaymentFlowProps {
  service: ServicePackage;
}
export const PaymentFlow: React.FC<PaymentFlowProps> = ({
  service
}) => {
  return <div className="w-full" data-id="element-167">
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200" data-id="element-168">
        <p className="text-sm text-gray-700 mb-4 text-center" data-id="element-169">
          Contact us for a personalised quote for this service
        </p>
        <div className="space-y-2" data-id="element-170">
          <a href="https://wa.me/YOURPHONENUMBER" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full px-4 py-2 text-white bg-green-600 rounded-md hover:bg-green-700 transition-colors" data-id="element-171">
            <MessageCircleIcon className="w-4 h-4 mr-2" data-id="element-172" />
            <span data-id="element-173">WhatsApp</span>
          </a>
          <a href="https://t.me/YOURUSERNAME" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full px-4 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors" data-id="element-174">
            <SendIcon className="w-4 h-4 mr-2" data-id="element-175" />
            <span data-id="element-176">Telegram</span>
          </a>
          <a href="mailto:info@debtrescue.it.com" className="flex items-center justify-center w-full px-4 py-2 text-white bg-red-700 rounded-md hover:bg-red-800 transition-colors" data-id="element-177">
            <MailIcon className="w-4 h-4 mr-2" data-id="element-178" />
            <span data-id="element-179">Email</span>
          </a>
        </div>
      </div>
    </div>;
};
export const ServiceCard: React.FC<{
  service: ServicePackage;
}> = ({
  service
}) => {
  return <div className={`border rounded-lg overflow-hidden ${service.recommended ? 'border-red-600' : 'border-gray-200'}`} data-id="element-180">
      {service.recommended && <div className="bg-red-600 text-white text-center py-1 text-sm font-medium" data-id="element-181">
          Recommended
        </div>}
      <div className="p-6" data-id="element-182">
        <h3 className="text-xl font-bold mb-2" data-id="element-183">{service.title}</h3>
        <p className="text-3xl font-bold mb-4" data-id="element-184">{service.price}</p>
        <ul className="mt-4 space-y-3 mb-6" data-id="element-185">
          {service.features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-186">
              <span className="text-gray-700" data-id="element-187">{feature}</span>
            </li>)}
        </ul>
        <PaymentFlow service={service} data-id="element-188" />
      </div>
    </div>;
};